import { ICardBrand } from './cardBrand.interface';

export const cardBrands: { [key: string]: ICardBrand } = {
    AMEX: {
        apiName: 'American Express',
        background: '#237d56',
        color: '#ffffff',
        cssId: 'amex',
        format: [4, 6, 5],
        iconId: 'amex-icon',
        logoId: 'amex-logo',
        maxChar: 15,
        minChar: 15,
    },
    AMEX2: {
        apiName: 'American_Express',
        background: '#237d56',
        color: '#ffffff',
        cssId: 'amex',
        format: [4, 6, 5],
        iconId: 'amex-icon',
        logoId: 'amex-logo',
        maxChar: 15,
        minChar: 15,
    },
    DINERS_CLUB: {
        apiName: 'Diners Club',
        background: '#237199',
        color: '#ffffff',
        cssId: 'diners-club',
        format: [4, 6, 4],
        iconId: 'dinersclub-icon',
        logoId: 'dinersclub-logo',
        maxChar: 14,
        minChar: 14,
    },
    DINERS_CLUB2: {
        apiName: 'Diners_Club',
        background: '#237199',
        color: '#ffffff',
        cssId: 'diners-club',
        format: [4, 6, 4],
        iconId: 'dinersclub-icon',
        logoId: 'dinersclub-logo',
        maxChar: 14,
        minChar: 14,
    },
    DISCOVER: {
        apiName: 'Discover',
        background: '#EEE8AA',
        color: '#333333',
        cssId: 'default',
        format: [4, 4, 4, 4],
        iconId: 'discover-icon',
        logoId: 'discover-logo',
        maxChar: 16,
        minChar: 16,
    },
    JCB: {
        apiName: 'JCB',
        background: '#9CD8FC',
        color: '#333333',
        cssId: 'default',
        format: [4, 4, 4, 4, 3],
        iconId: 'jcb-icon',
        logoId: 'jcb-logo',
        maxChar: 19,
        minChar: 16,
    },
    MAESTRO: {
        apiName: 'Maestro',
        background: '#bebebe',
        color: '#333333',
        cssId: 'maestro',
        format: [4, 4, 4, 4, 3],
        iconId: 'maestro-icon',
        logoId: 'maestro-logo',
        maxChar: 19,
        minChar: 13,
    },
    MASTER_CARD: {
        apiName: 'MasterCard',
        background: '#000000',
        color: '#ffffff',
        cssId: 'mastercard',
        format: [4, 4, 4, 4],
        iconId: 'mastercard-icon',
        logoId: 'mastercard-logo',
        maxChar: 16,
        minChar: 13,
    },
    MASTER_CARD2: {
        apiName: 'Master_Card',
        background: '#000000',
        color: '#ffffff',
        cssId: 'mastercard',
        format: [4, 4, 4, 4],
        iconId: 'mastercard-icon',
        logoId: 'mastercard-logo',
        maxChar: 16,
        minChar: 13,
    },
    UNKNOWN: {
        apiName: 'Unknown',
        background: '#666666',
        color: '#ffffff',
        cssId: 'default',
        format: [4, 4, 4, 4],
        iconId: '',
        logoId: 'default-logo',
        maxChar: 20,
        minChar: 12,
    },
    VISA: {
        apiName: 'Visa',
        background: '#162678',
        color: '#ffffff',
        cssId: 'visa',
        format: [4, 4, 4, 4, 3],
        iconId: 'visa-icon',
        logoId: 'visa-logo',
        maxChar: 19,
        minChar: 13,
    },
    UNIONPAY: {
        apiName: 'UnionPay',
        background: '#9C9C9C',
        color: '#000000',
        cssId: 'unionpay',
        format: [4, 4, 4, 4, 3],
        iconId: 'unionpay-icon',
        logoId: 'unionpay-logo',
        maxChar: 19,
        minChar: 16,
    },
};
